
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Toulouse dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Toulouse certifiée Google Partner, accompagne les entreprises toulousaines pour décupler leur visibilité en ligne et générer plus de prospects.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Toulouse dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Toulouse certifiée Google Partner, accompagne les entreprises toulousaines pour décupler leur visibilité en ligne et générer plus de prospects.",
        },
      ],
    };
  },
};
